/*
 * @Author: 李朋飞
 * @Date: 2021-07-12 16:19:03
 * @LastEditTime: 2021-07-12 16:19:22
 * @Description: 
 */
import Pagination from './Pagination';

export default {
  install(Vue) {
    Vue.component('Pagination', Pagination);
  }
};


// WEBPACK FOOTER //
// ./src/components/Pagination/index.js